module.exports = __webpack_public_path__ + "media/yichang.1cc0589f.wav";